<template>
  <b-row class="mt-5">
    <!-- Skeleton loaders -->
    <template v-if="isLoading">
      <b-col xl="6" lg="12" md="12">
        <b-form>
          <!-- General info loaders start -->
          <b-form-group
            class="
              d-flex
              primary-dark
              general-info-form-group
              full-width-form
              w-100
              mb-5
            "
            label="General info"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto mt-2">
                  <b-col class="mb-4" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Customer name *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col class="mt-3" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Date of Birth"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-4 mt-3" md="12">
                    <b-form-group class="position-relative" label="Linkedin">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>

          <b-form-group
            class="d-flex primary-dark general-info-form-group w-100 mt-5"
            label="Account info"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto mt-4">
                  <b-col class="mt-3 mb-4" md="12">
                    <b-form-group class="position-relative" label="Company *">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-4" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Billing Entity"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="6">
                    <b-form-group
                      class="position-relative"
                      label="Subscription *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="6">
                    <b-form-group
                      class="position-relative"
                      label="Subscription hours per month *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Profile type *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Assistants *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="6">
                    <b-form-group
                      class="position-relative"
                      label="Start date *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="6">
                    <b-form-group class="position-relative" label="End date *">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="12">
                    <b-form-group class="position-relative" label="Timezone">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>

                  <b-col class="mb-4" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Infrastructure"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
          <!-- Account info loaders end -->
        </b-form>
      </b-col>
      <!-- Left column loaders end -->

      <!-- Right column loaders start -->
      <b-col xl="6" lg="12" md="12">
        <b-form>
          <!-- Goals loaders start -->
          <b-form-group
            class="
              d-flex
              primary-dark
              general-info-form-group
              full-width-form
              w-100
            "
            label="Goals"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap w-100">
                <b-row class="w-100 my-0 mx-auto mt-4">
                  <b-col class="mb-4" md="12">
                    <b-skeleton
                      height="1.6rem"
                      width="50%"
                      class="mb-2 mt-2"
                    ></b-skeleton>
                    <b-skeleton
                      height="8rem"
                      class="mb-5"
                      type="input"
                    ></b-skeleton>
                  </b-col>
                  <b-col class="mb-4 mt-3" md="12">
                    <b-skeleton
                      height="1.6rem"
                      width="50%"
                      class="mb-2 mt-2"
                    ></b-skeleton>
                    <b-skeleton
                      height="8rem"
                      class="mb-5"
                      type="input"
                    ></b-skeleton>
                  </b-col>
                  <b-col class="mb-4 mt-3" md="12">
                    <b-skeleton
                      height="1.6rem"
                      width="50%"
                      class="mb-2 mt-2"
                    ></b-skeleton>
                    <b-skeleton
                      height="8rem"
                      class="mb-5"
                      type="input"
                    ></b-skeleton>
                  </b-col>
                  <b-col class="mb-4 mt-3" md="12">
                    <b-skeleton
                      height="1.6rem"
                      width="50%"
                      class="mb-2 mt-2"
                    ></b-skeleton>
                    <b-skeleton
                      height="8rem"
                      class="mb-3"
                      type="input"
                    ></b-skeleton>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
          <!-- Goals loader end -->
          <!-- Location info loaders start -->
          <b-form-group
            class="d-flex primary-dark general-info-form-group w-100 mt-5"
            label="Location"
          >
            <b-card class="d-flex flex-column general-info-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto mt-4">
                  <b-col md="6">
                    <b-form-group class="position-relative" label="Country *">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" class="mb-5">
                    <b-form-group class="position-relative" label="City *">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-5 mt-3" md="12">
                    <b-form-group
                      class="position-relative"
                      label="Address line 1 *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" class="mt-3">
                    <b-form-group
                      class="position-relative"
                      label="Address line 2 *"
                    >
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                  <b-col md="6" class="mb-5 mt-3">
                    <b-form-group class="position-relative" label="Zip code *">
                      <b-skeleton height="4rem" type="input"></b-skeleton>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
          <!-- Location info loaders end -->
        </b-form>
      </b-col>
    </template>
    <!-- Right column loaders end -->
    <!-- End loaders -->

    <template v-else>
      <b-col xl="6" lg="12" md="12">
        <ValidationObserver ref="leftColForm">
          <b-form>
            <b-form-group
              class="d-flex primary-dark general-info-form-group"
              label="General info"
            >
              <b-card class="d-flex flex-column general-info-card">
                <!-- Customer avatar starts -->
                <div class="d-flex flex-wrap mt-2">
                  <b-row class="w-100 my-0 mx-auto mb-4" align-v="center">
                    <b-col
                      md="3"
                      class=""
                      style="margin-left: 15px; padding: 0"
                    >
                      <b-avatar
                        v-if="avatar"
                        :src="avatar"
                        size="11rem"
                      ></b-avatar>
                      <b-avatar
                        v-else
                        class="bg--primary"
                        :text="avatarName"
                        size="11rem"
                      ></b-avatar>
                    </b-col>
                    <b-col md="6">
                      <label
                        class="
                          font-sm
                          file-select
                          mt-3
                          cursor-pointer
                          action-text
                        "
                      >
                        <p class="secondary--text">Click to upload/update</p>
                        <p class="secondary--text reduce-whitespace">
                          profile picture *
                        </p>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          @click="uploadClear"
                          @change="uploadFile"
                        />
                      </label>
                      <h6
                        v-if="photoFileTypeError"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                        "
                      >
                        Incorrect file type. Please upload an image.
                      </h6>
                      <h6
                        v-if="photoError"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                        "
                      >
                        Please update profile picture
                      </h6>
                      <h6
                        v-if="photoTokenError"
                        class="
                          font-sm font-family-regular
                          position-relative
                          danger
                        "
                      >
                        User token expired. Please logout and login again.
                      </h6>
                    </b-col>
                  </b-row>
                </div>
                <!-- Customer avatar end -->

                <div class="d-flex flex-wrap">
                  <!-- General info form start -->
                  <b-row class="w-100 my-0 mx-auto mt-1">
                    <b-col class="mb-4" md="12">
                      <ValidationProvider
                        name="Customer name"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          label="Customer name *"
                        >
                          <b-form-input
                            :disabled="isFieldsDisabled"
                            v-model="customerName"
                            type="text"
                            @change="saveCustomerBasicDetails"
                            placeholder="Enter customer name"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-3 mt-3" md="12">
                      <ValidationProvider
                        name="dateofbirth"
                        rules="dob"
                        ref="dobValidator"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Date of Birth">
                          <b-input-group>
                            <b-form-input
                              v-model="birthDate"
                              type="text"
                              @change="saveCustomerBasicDetails"
                              placeholder="YYYY-MM-DD"
                              autocomplete="off"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-form-datepicker
                                v-model="birthDate"
                                style="z-index: 1"
                                :max="maxBirthDate"
                                :min="minBirthDate"
                                button-only
                                @input="saveCustomerBasicDetails"
                                class="datepicker"
                                :show-decade-nav="true"
                                right
                                locale="en-US"
                                aria-controls="example-input"
                              >
                                <template #button-content="">
                                  <img
                                    src="@/assets/icons/date-picker.svg"
                                    alt=""
                                  />
                                </template>
                              </b-form-datepicker>
                            </b-input-group-append>
                          </b-input-group>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-4 mt-3" md="12">
                      <ValidationProvider
                        name="Email"
                        rules="required|email"
                        ref="emailValidator"
                        v-slot="{ errors }"
                      >
                        <b-form-group class="position-relative" label="Email *">
                          <b-form-input
                            placeholder="Enter email"
                            @change="saveCustomerBasicDetails"
                            v-model="emailAddress"
                            :disabled="isFieldsDisabled"
                            type="text"
                            @input="emailError = false"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                          <h6
                            v-if="emailError"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            User with this email already exist
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-3" md="12">
                      <ValidationProvider
                        name="linkedInURL"
                        ref="linkedInValidator"
                        rules="linkedinRegex"
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          label="Linkedin"
                        >
                          <b-form-input
                            :disabled="isFieldsDisabled"
                            v-model="linkedInURL"
                            @change="updateCustomerOtherDetails"
                            type="text"
                            placeholder="Enter linkedin URL"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-form-group>
            <!-- General info form end -->

            <b-form-group
              class="d-flex general-info-form-group primary-dark mt-5"
              label="Account info"
            >
              <b-card class="d-flex flex-column location-card">
                <div class="d-flex flex-wrap">
                  <b-row class="w-100 my-0 mx-auto mt-1">
                    <!-- Customer Company -->
                    <b-col class="mb-3" md="12" v-if="!isEditCompanyDisabled">
                      <ValidationProvider
                        name="customerCompany"
                        rules="required"
                      >
                        <b-form-group
                          for="customerCompany"
                          class="position-relative"
                          label="Company *"
                        >
                          <multiselect
                            placeholder="Select company"
                            v-model="customerCompany"
                            label="text"
                            track-by="value"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            hideSelected
                            class="custom-multiselect"
                            @input="onSelectCompany"
                            :options="companies"
                            :allow-empty="false"
                          >
                            <template
                              slot="singleLabel"
                              slot-scope="{ option }"
                            >
                              {{ ellipsify(option.text, 45) }}
                            </template>
                            <template slot="noResult">
                              No companies found
                            </template>
                          </multiselect>
                          <h6
                            v-if="!customerCompany.value"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ requiredField }}
                          </h6>
                          <h6
                            v-if="companyMaxSeatsError"
                            class="font-sm font-family-regular danger"
                          >
                            {{ companyMaxSeatsError }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <!-- Customer Company end-->

                    <!-- Customer - View only details -->
                    <b-col class="mb-3" md="12" v-if="isEditCompanyDisabled">
                      <b-form-group class="position-relative" label="Company">
                        <b-form-input
                          :disabled="true"
                          v-model="customerCompany.text"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-3" md="12">
                      <b-form-group
                        class="position-relative"
                        label="Billing Entity"
                      >
                        <b-form-input
                          :disabled="true"
                          v-model="billingEntity"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-3" md="6">
                      <b-form-group
                        class="position-relative"
                        label="Subscription"
                      >
                        <b-form-input
                          :disabled="true"
                          v-model="customerMembership"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-3" md="6">
                      <ValidationProvider
                        name="customerHours"
                        ref="customerHoursValidator"
                        rules="customerHours"
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          label="Subscription Hours"
                        >
                          <b-form-input
                            :disabled="role != 'admin'"
                            v-model="customerHours"
                            @change="updateCustomerOtherDetails"
                            type="text"
                            placeholder="Enter customer subscription hours"
                          ></b-form-input>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <!-- Customer - View only details end-->

                    <b-col class="mb-4" md="12">
                      <ValidationProvider
                        name="profileType"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group class="position-relative">
                          <label for="profileType" class="font-sm"
                            >Profile type *
                            <span class="tooltips"
                              >&#9432;
                              <div class="tooltiptext pt-4 px-3">
                                <p class="reduce-whitespace-2">
                                  A. Techy/less personal
                                </p>
                                <p class="reduce-whitespace-2">
                                  B. Good with people/relaxed
                                </p>
                                <p class="reduce-whitespace-2">
                                  C. Dominant/formal
                                </p>
                                <p class="reduce-whitespace-2">D. Formal</p>
                              </div>
                            </span></label
                          >
                          <multiselect
                            placeholder="Select Profile Type"
                            v-model="selectedProfileType"
                            @input="updateCustomerOtherDetails"
                            label="text"
                            class="
                              custom-multiselect
                              cy-new-intake-infra
                              categories-multiselect
                            "
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :options="profileTypes"
                            :multiple="true"
                          >
                            <template slot="noResult"
                              >No profile found</template
                            ></multiselect
                          >
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col class="mb-5" md="12">
                      <ValidationProvider
                        name="assistantsList"
                        rules=""
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          id="assistant-multiselect-wrapper"
                          label="Assistants *"
                        >
                          <multiselect
                            @select="onAddAssistant"
                            @remove="onRemoveAssistant"
                            :disabled="!enableAssistantSelect"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :value="selectedAssistants"
                            placeholder="Select assistants"
                            label="text"
                            trackBy="profileId"
                            :option-height="40"
                            :options="assistantsList"
                            :multiple="true"
                            :taggable="true"
                            class="custom-multiselect assistant-multiselect"
                          >
                            <template
                              slot="tag"
                              slot-scope="{ option, remove }"
                            >
                              <div
                                class="assistant-tag"
                                :id="`tag-${option.profileId}`"
                                @mousedown.stop.prevent=""
                              >
                                <div class="avatar-wrapper">
                                  <b-avatar
                                    size="3rem"
                                    class="bg--primary"
                                    :src="option.avatarThumbnail"
                                    :text="getInitials(option.text)"
                                  ></b-avatar>
                                </div>
                                <div class="title-wrapper">
                                  <div class="title">{{ option.text }}</div>
                                </div>
                                <div
                                  class="primary-label"
                                  v-if="option.isDefault"
                                >
                                  <span>Primary</span>
                                </div>
                                <div class="close-wrapper">
                                  <b-icon
                                    icon="x"
                                    @click.stop.prevent="
                                      onRemoveOption(option, remove)
                                    "
                                  />
                                </div>
                              </div>
                              <RemoveEATooltip 
                                :isPrimaryEA="isUserPrimaryEA"
                                :isSecondaryEA="isUserSecondaryEA"
                                :isDefault="option.isDefault"
                                :profileUserId="loggedInUser.profileUserId"
                                :profileId="option.profileId"
                                :openTaskCount="option.assistantOpenTasksCount"
                                :openHandoverCount="option.assistantOpenHandoverTasksCount"
                              />
                            </template>
                          </multiselect>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col class="mb-5" md="12">
                      <b-form-group
                        class="position-relative"
                        id="owner-multiselect-wrapper"
                        label="Owners"
                      >
                        <multiselect
                          @open="ensureOwnersLoaded"
                          @select="onAddOwner"
                          @remove="onRemoveOwner"
                          :disabled="!canEditOwners"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          :value="selectedOwners"
                          placeholder="Select owners"
                          label="text"
                          trackBy="profileId"
                          :option-height="40"
                          :options="availableOwnersList"
                          :multiple="true"
                          class="custom-multiselect assistant-multiselect"
                        >
                          <template slot="tag" slot-scope="{ option }">
                            <div
                              class="assistant-tag"
                              :id="`owner-tag-${option.profileId}`"
                              @mousedown.stop.prevent=""
                            >
                              <div class="avatar-wrapper">
                                <b-avatar
                                  size="3rem"
                                  class="bg--primary"
                                  :src="option.avatarThumbnail"
                                  :text="getInitials(option.text)"
                                ></b-avatar>
                              </div>
                              <div class="title-wrapper">
                                <div class="title">{{ option.text }}</div>
                              </div>
                              <div class="close-wrapper" v-if="canEditOwners">
                                <b-icon
                                  icon="x"
                                  @click.stop.prevent="onRemoveOwner(option)"
                                />
                              </div>
                            </div>
                          </template>
                          <template slot="noResult">No owners found</template>
                          <template slot="noOptions">{{
                            ownerPickerEmptyMessage
                          }}</template>
                        </multiselect>
                        <h6
                          v-if="ownerError"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ ownerError }}
                        </h6>
                      </b-form-group>
                    </b-col>

                    <b-col class="mb-4" md="6">
                      <ValidationProvider
                        ref="startDateValidator"
                        name="startDate"
                        rules="required|dated|dateDifference:@confirm"
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          label="Start date *"
                        >
                          <b-input-group>
                            <b-form-input
                              id="example-input"
                              v-model="startDate"
                              @change="updateCustomerOtherDetails"
                              :disabled="isFieldsDisabled"
                              type="text"
                              placeholder="Select date"
                              autocomplete="off"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-form-datepicker
                                button-only
                                :max="endDate"
                                @input="updateCustomerOtherDetails"
                                :show-decade-nav="true"
                                v-model="startDate"
                                :disabled="isFieldsDisabled"
                                class="datepicker"
                                right
                                locale="en-US"
                                aria-controls="example-input"
                              >
                                <template #button-content="">
                                  <img
                                    src="@/assets/icons/date-picker.svg"
                                    alt=""
                                  />
                                </template>
                              </b-form-datepicker>
                            </b-input-group-append>
                          </b-input-group>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-relative
                              danger
                              reduced-line-height
                              mb-3
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4" md="6">
                      <ValidationProvider
                        name="confirm"
                        rules="dated"
                        ref="endDateValidator"
                        v-slot="{ errors }"
                      >
                        <b-form-group
                          class="position-relative"
                          label="End date"
                        >
                          <b-input-group>
                            <b-form-input
                              id="example-input"
                              type="text"
                              data-cy="input-end-date-container"
                              @change="updateCustomerOtherDetails"
                              placeholder="Select date"
                              v-model="endDate"
                              :disabled="isFieldsDisabled"
                              autocomplete="off"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-form-datepicker
                                data-cy="input-end-date"
                                button-only
                                v-model="endDate"
                                :min="startDate"
                                class="datepicker"
                                @input="updateCustomerOtherDetails"
                                :disabled="isFieldsDisabled"
                                right
                                locale="en-US"
                                aria-controls="example-input"
                                :show-decade-nav="true"
                              >
                                <template #button-content="">
                                  <img
                                    src="@/assets/icons/date-picker.svg"
                                    alt=""
                                  />
                                </template>
                              </b-form-datepicker>
                            </b-input-group-append>
                          </b-input-group>
                          <h6
                            v-if="errors[0]"
                            class="
                              font-sm font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4" md="12">
                      <ValidationProvider
                        name="Time zone field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Timezone *">
                          <b-form-select
                            :options="timeZone"
                            @change="updateCustomerOtherDetails"
                            v-model="selectedTimeZone"
                          ></b-form-select>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-timezone-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Infrastructure field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Infrastructure *">
                          <multiselect
                            placeholder="Select Infrastructure"
                            v-model="infrastructure"
                            label="text"
                            track-by="id"
                            selectLabel=""
                            @input="updateCustomerOtherDetails"
                            deselectLabel=""
                            selectedLabel=""
                            class="
                              custom-multiselect
                              cy-new-intake-infra
                              categories-multiselect
                            "
                            :options="infraOptions"
                            :multiple="true"
                          >
                            <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc">
                                <span class="option__title">
                                  {{ props.option.title }}
                                </span>
                              </span>
                            </template>
                          </multiselect>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-infra-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                            data-cy="customer-infra-required-error"
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-form-group>
          </b-form>
        </ValidationObserver>
      </b-col>
      <!-- Left form column end -->

      <!-- Right form column start -->
      <b-col xl="6" lg="12" md="12">
        <ValidationObserver ref="rightColForm">
          <b-form>
            <b-form-group
              class="
                d-flex
                general-info-form-group
                full-width-form
                w-100
                primary-dark
                mb-5
              "
              label="Goals"
            >
              <b-card class="d-flex flex-column general-info-card px-4 py-1">
                <b-form-group
                  v-for="(item, index) in questions"
                  :key="item.id"
                  :label="`${item.formQuestion.question.title} *`"
                  class="answers-form-group"
                >
                  <ValidationObserver ref="answersObserver">
                    <ValidationProvider
                      name="answers"
                      rules="required"
                      ref="questionsValidator"
                      v-slot="{ errors }"
                    >
                      <b-form-textarea
                        autocomplete="off"
                        rows="3"
                        @change="patchIntake(index)"
                        no-resize
                        :disabled="isFieldsDisabled"
                        v-model="item.answer.answer"
                      ></b-form-textarea>
                      <h6
                        v-if="errors[0]"
                        class="
                          font-sm
                          position-absolute
                          font-family-regular
                          danger
                        "
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </ValidationObserver>
                </b-form-group>
              </b-card>
            </b-form-group>
          </b-form>
          <!-- Location form start -->

          <b-form-group
            class="d-flex primary-dark mt-5 general-info-form-group"
            label="Location"
          >
            <b-card class="d-flex flex-column location-card">
              <div class="d-flex flex-wrap">
                <b-row class="w-100 my-0 mx-auto mt-1">
                  <b-col class="mb-4" md="6">
                    <b-form-group label="Country *">
                      <ValidationProvider
                        name="Country"
                        rules="requiredCountry"
                        v-slot="{ errors }"
                      >
                        <multiselect
                          placeholder="Select country"
                          v-model="selectedCountry"
                          label="text"
                          @select="saveAddress"
                          track-by="text"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          hideSelected
                          class="custom-multiselect countries-multiselect"
                          :options="countries"
                        >
                          <template slot="singleLabel" slot-scope="{ option }">
                            {{ ellipsify(option.text, 20) }}
                          </template>
                          <template slot="noResult"
                            >No countries found</template
                          ></multiselect
                        >
                        <h6
                          class="
                            font-sm
                            mb-3
                            font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </ValidationProvider>
                    </b-form-group>
                  </b-col>
                  <b-col class="mb-5" md="6">
                    <ValidationProvider
                      name="City"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group class="position-relative" label="City *">
                        <b-form-input
                          placeholder="Enter city name"
                          type="text"
                          @change="saveAddress"
                          :disabled="isFieldsDisabled"
                          v-model="selectedCity"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <b-col class="mb-2" md="12">
                    <ValidationProvider
                      name="addressLineOne"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group
                        class="position-relative"
                        label="Business address line 1 *"
                      >
                        <b-form-input
                          placeholder="Business address"
                          type="text"
                          @change="saveAddress"
                          :disabled="isFieldsDisabled"
                          v-model="homeAddress.streetName"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col class="mb-3" md="6">
                    <ValidationProvider
                      name="addressLineTwo"
                      v-slot="{ errors }"
                    >
                      <b-form-group
                        class="position-relative"
                        label="Business address line 2"
                      >
                        <b-form-input
                          placeholder="Enter another address"
                          type="text"
                          @change="saveAddress"
                          :disabled="isFieldsDisabled"
                          v-model="homeAddress.streetNumber"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>

                  <b-col class="mb-3" md="6">
                    <ValidationProvider
                      name="Zip code"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <b-form-group
                        class="position-relative"
                        label="Zip code *"
                      >
                        <b-form-input
                          placeholder="Enter zip code"
                          type="text"
                          @change="saveAddress"
                          :disabled="isFieldsDisabled"
                          v-model="homeAddress.postalCode"
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-form-group>
          <b-form-group
            class="
              d-flex
              general-info-form-group
              mt-5
              full-width-form
              w-100
              primary-dark
              mb-5
            "
            label="Communication Platforms"
          >
            <b-card
              class="d-flex flex-column general-info-card px-4 py-1"
              v-if="communications.length > 0"
            >
              <b-row
                v-for="item in communications"
                :key="item.id"
                class="mb-4 mt-2 d-flex align-items-center nowrap w-100 px-3"
              >
                <ValidationProvider
                  name="email"
                  class="validationSpan"
                  :rules="
                    item.communication.medium === 'Assistant Email'
                      ? 'email'
                      : ''
                  "
                  v-slot="{ errors }"
                >
                  <b-row align-v="center" align-h="start" class="mb-4">
                    <b-col md="5">
                      <div class="mr-4 d-flex align-items-center">
                        <p class="font-weight-normal">
                          {{ item.communication.medium }}
                        </p>
                      </div>
                    </b-col>

                    <b-col
                      md="7"
                      class="communications-textbox position-absolute"
                    >
                      <b-form-group>
                        <b-form-input
                          autocomplete="off"
                          size="lg"
                          type="text"
                          @change="updateCommunications"
                          :placeholder="
                            item.communication.medium === 'Phone'
                              ? 'Mobile Number'
                              : 'N/A'
                          "
                          v-model="item.value"
                          :disabled="
                            isDelete === true ||
                            isDelete === false ||
                            item.communication.medium === 'Zoom'
                          "
                        ></b-form-input>
                        <h6
                          v-if="errors[0]"
                          class="
                            font-sm font-family-regular
                            position-absolute
                            reduce-line-height
                            danger
                          "
                        >
                          {{ errors[0] }}
                        </h6>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </ValidationProvider>
              </b-row>
            </b-card>

            <b-card
              class="d-flex flex-column general-info-card px-4 py-1"
              v-else
            >
              <b-row
                v-for="item in defaultCommunications"
                :key="item.id"
                class="mb-4 mt-2 d-flex align-items-center nowrap w-125"
              >
                <b-col md="4">
                  <div
                    class="communication-icons mr-4 d-flex align-items-center"
                  >
                    <img
                      class="position-relative reduce-whitespace-2"
                      :src="item.communication.mediumThumbnail"
                      v-show="false"
                      alt
                    />
                    <p
                      :class="[
                        item.communication.medium === 'Secondary Email'
                          ? 'reduce-line-height'
                          : null,
                      ]"
                      class="ml-5 font-weight-normal"
                    >
                      {{ item.communication.medium }}
                    </p>
                  </div>
                </b-col>

                <b-col md="8" class="communications-textbox position-relative">
                  <b-form-group>
                    <b-form-input
                      autocomplete="off"
                      size="lg"
                      type="text"
                      @change="updateCommunications"
                      placeholder="N/A"
                      v-model="item.value"
                      :disabled="isFieldsDisabled"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-form-group>
        </ValidationObserver>
        <!-- Location form end -->
      </b-col>
    </template>
    <b-col v-if="showAlert" md="12" class="position-relative mt-4 pr-0">
      <b-alert
        class="alert-btn-top custom-alert"
        :show="showAlert"
        :fade="true"
        >{{ alertMsg }}</b-alert
      >
    </b-col>
    <b-col>
      <b-button
        v-show="false"
        :disabled="showUnarchivedBtn"
        @click="saveAllInfo"
        :class="[showAlert ? 'mt-3' : 'mt-5']"
        class="btn-pill mb-5 px-5 py-3"
      >
        <b-spinner
          v-if="isSaving"
          style="width: 14px; height: 14px"
          variant="light"
          label="Spinning"
        ></b-spinner>
        {{ `${!isSaving ? "Save" : ""}` }}
      </b-button>
      <b-dropdown-divider v-if="!internalCustomer && !isOwnerUser" class="" />

      <!-- Deactivation/Deletion is admin+EA only; Owners are read-only. -->
      <b-row
        class="d-flex flex-column mt-5 mb-5"
        v-if="!internalCustomer && !isOwnerUser"
      >
        <b-col md="9" lg="9" xl="6">
          <h6 class="font-sm primary--text font-family-medium">
            Deactivation/Deletion
          </h6>
          <b-card class="py-2" no-body>
            <b-card-body class="px-5">
              <b-row class="mx-0 position-relative" align-v="center">
                <b-col sm="12" md="8" lg="8" xl="7" class="px-0">
                  <h6 class="font-sm primary--text font-family-medium">
                    Unsubscribe customer email
                  </h6>
                  <h6 class="font-sm secondary--text">
                    Unsubscribe the customer from receiving weekly usage report email. 
                    The weekly reports can be resumed by re-activating the email.
                  </h6>
                </b-col>
                <b-col
                  md="4"
                  xl="3"
                  lg="3"
                  sm="6"
                  class="
                    position-absolute
                    archive-btn-container
                    d-flex
                    justify-content-end
                  "
                >
                <b-form-checkbox
                  size="lg"
                  id="checkbox-1"
                  v-model="isBlacklisted"
                  name="checkbox-1"
                  @change="updateCustomerOtherDetails"
                  button
                  class="custom-checkbox"
                >
                <span>Unsubscribe: {{ isBlacklisted }}</span>
                </b-form-checkbox>
                </b-col>
              </b-row>
              <b-dropdown-divider class="mt-5" />
              <b-row class="mx-0 position-relative" align-v="center">
                <b-col sm="12" md="8" lg="8" xl="7" class="px-0">
                  <h6 class="font-sm mt-5 primary--text font-family-medium">
                    Archive Account
                  </h6>
                  <h6 class="font-sm secondary--text">
                    Deactivate Customer's account on temporary basis. All the
                    information about the account will be still saved and can be
                    re-used once the account is re-activated in future.
                  </h6>
                </b-col>
                <b-col
                  md="4"
                  xl="3"
                  lg="3"
                  sm="6"
                  class="
                    position-absolute
                    archive-btn-container
                    d-flex
                    justify-content-end
                  "
                >
                  <b-button
                    v-if="!showUnarchivedBtn"
                    @click="archiveAccount"
                    class="btn-pill px-5 py-3 btn-primary d-flex"
                  >
                    <b-spinner
                      v-if="isSavingArchive"
                      style="width: 14px; height: 14px"
                      variant="light"
                      label="Spinning"
                    ></b-spinner>

                    <div
                      v-if="!isSavingArchive"
                      class="d-flex align-items-center"
                    >
                      <img src="@/assets/icons/arrow_down_square_btn.svg" alt />
                      <p
                        class="
                          position-relative
                          ml-2
                          btn-top btn-line-height
                          font-family-medium
                        "
                      >
                        Archive
                      </p>
                    </div>
                  </b-button>
                  <b-button
                    v-if="showUnarchivedBtn"
                    :disabled="isAccountDeleted"
                    @click="unArchiveAccount"
                    class="btn-pill px-5 py-3 btn-primary d-flex"
                  >
                    <b-spinner
                      v-if="isSavingUnarchive"
                      style="width: 14px; height: 14px"
                      variant="light"
                      label="Spinning"
                    ></b-spinner>

                    <div
                      v-if="!isSavingUnarchive"
                      class="d-flex align-items-center"
                    >
                      <img src="@/assets/icons/arrow_down_square_btn.svg" alt />
                      <p
                        class="
                          position-relative
                          ml-2
                          font-family-medium
                          btn-top btn-line-height
                        "
                      >
                        Unarchive
                      </p>
                    </div>
                  </b-button>
                </b-col>
              </b-row>
              <b-dropdown-divider v-if="role === 'admin'" class="mt-5" />
              <h6
                v-if="role === 'admin'"
                class="font-sm mt-5 primary--text font-family-medium"
              >
                Permanently Delete Account
              </h6>
              <b-row class="mx-0 position-relative" v-if="role === 'admin'">
                <b-col md="8" sm="12" xl="8" lg="7" class="px-0">
                  <h6 class="font-sm secondary--text">
                    Delete client's account permanently. All the information
                    about the account will be erased.
                  </h6>
                </b-col>
                <b-col
                  class="
                    px-0
                    position-absolute
                    delete-container
                    d-flex
                    justify-content-end
                  "
                  md="4"
                  sm="6"
                  lg="3"
                  xl="3"
                >
                  <b-button
                    :disabled="isAccountDeleted"
                    @click="deleteAccount"
                    class="
                      btn-pill
                      px-5
                      py-3
                      btn-danger
                      position-relative
                      btn-bottom
                    "
                  >
                    <b-spinner
                      v-if="isDeletingAccount"
                      style="width: 14px; height: 14px"
                      variant="light"
                      label="Spinning"
                    ></b-spinner>
                    <div
                      v-if="!isDeletingAccount"
                      class="d-flex align-items-center"
                    >
                      <img src="@/assets/icons/btn_delete_append.svg" alt />
                      <p
                        class="
                          position-relative
                          btn-line-height
                          font-family-medium
                          ml-2
                          btn-top
                        "
                      >
                        Delete
                      </p>
                    </div>
                  </b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
    <b-modal
      body-class="logout-modal-body"
      hide-header
      hide-footer
      size="md"
      visible
      centered
      v-model="deleteModal.visible"
      no-close-on-esc
      no-close-on-backdrop
    >
      <b-button class="close-button">
        <img
          class="close-icon"
          src="@/assets/icons/close_sidebar.svg"
          alt
          @click="deleteModal.visible = false"
        />
      </b-button>

      <div class="title-row primary-dark font-lg">
        <h1>Are you sure?</h1>
      </div>
      <div class="desc-row font-lg">
        <h3 v-if="deleteModal.isPrimaryEA">
          The following Primary EA will be removed.
        </h3>
        <h3 v-else>
          Do you want to remove {{ deleteModal.removedOption.text }} from
          {{ customerName }}'s profile?
          {{ deleteModal.removedOption.text }} will no longer have access to
          this customer profile.
        </h3>
      </div>
      <div class="info-wrapper">
        <div>
          <b-avatar
            v-if="deleteModal.removedOption.avatarThumbnail"
            :src="deleteModal.removedOption.avatarThumbnail"
            size="8rem"
            class="pa-avatar bg--primary"
          ></b-avatar>
          <b-avatar
            v-else
            :text="getInitials(deleteModal.removedOption.text)"
            size="8rem"
            class="pa-avatar bg--primary"
          ></b-avatar>
        </div>
        <div class="d-flex flex-column ml-4 ea-info">
          <p class="font-family-medium primary--text">
            {{ deleteModal.removedOption.text }}
          </p>
          <p class="secondary--text">
            {{ parseInt(deleteModal.removedOption.workHours) }} hours/week
          </p>
        </div>
        <div class="right-button-wrapper" v-if="!deleteModal.isPrimaryEA">
          <b-button
            class="btn-delete btn-pill"
            :disabled="deleteModal.loading"
            @click="removeAssistant"
          >
            <template v-if="deleteModal.loading">
              <b-spinner />
            </template>
            <template v-else> Remove </template>
          </b-button>
        </div>
      </div>
      <b-dropdown-divider
        class="modal-divider"
        v-if="deleteModal.isPrimaryEA"
      />
      <div class="select-row" v-if="deleteModal.isPrimaryEA">
        <div class="font-md" :style="{ paddingBottom: '10px' }">
          <h3>Select New Primary EA</h3>
        </div>
        <b-form-select
          :options="computedAssistants"
          v-model="deleteModal.selectedEAId"
          placeholder="Select Primary EA"
        >
        </b-form-select>
      </div>
      <div class="button-row" v-if="deleteModal.isPrimaryEA">
        <b-button
          class="btn-delete btn-pill"
          :disabled="disableDeleteButton"
          @click="changePrimaryAssistant"
        >
          <template v-if="deleteModal.loading">
            <b-spinner />
          </template>
          <template v-else> Confirm </template>
        </b-button>
      </div>
    </b-modal>
    <b-modal
      centered
      no-close-on-esc
      hide-header
      hide-footer
      no-close-on-backdrop
      title="Upload Profile Picture"
      v-model="showCropper"
    >
      <b-container fluid>
        <div>
          <p>Upload Image</p>
        </div>
        <div>
          <img
            id="image"
            :src="fileURL"
            ref="source"
            class="cropper-hidden w-100"
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-button
            v-if="!cropperLoading"
            class="btn-cancel btn-primary px-5 py-3 btn-pill mt-3 mb-3"
            @click.prevent="resetModal"
          >
            Cancel
          </b-button>
          <b-button
            class="btn-cancel px-5 py-3 btn-pill mt-3 mb-3 ml-3"
            @click.prevent="submitImage"
            :disabled="cropperLoading"
          >
            <b-spinner
              v-if="cropperLoading"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${!cropperLoading ? "Save" : ""}` }}
          </b-button>
        </div>
      </b-container>
    </b-modal>
    <b-modal
      centered
      modal-class="cy-current-customer-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showArchive"
      v-if="isCustomerArchived"
    >
      <b-container fluid>
        <b-button
          @click="closeArchiveModal"
          class="cy-current-customer-close d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 v-if="isCustomerArchived" class="font-md modal_header ml-4">
            Successfully archived
          </h2>
          <h4 class="font-md subtext mb-4 mt-1 ml-4">
            Following customer has been successfully archived.
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col md="9" class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="avatar"
                :src="avatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else-if="firstName && lastName"
                :text="getInitials(`${firstName} ${lastName}`)"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div
              class="
                d-flex
                flex-column
                justify-content-center
                position-relative
                ml-4
              "
            >
              <p
                class="
                  cy-current-customer-fullName
                  font-family-medium
                  primary--text
                  mt-2
                "
              >
                {{ `${firstName} ${lastName}` }}
              </p>
              <p
                class="
                  cy-current-customer-email
                  secondary--text
                  reduce-whitespace
                "
              >
                {{ emailAddress }}
              </p>
            </div>
          </b-col>
          <div class="button-wrapper">
            <b-button
              @click="gotoCustomerListing"
              class="btn-primary px-5 py-3 btn-pill reduce-whitespace mr-5"
            >
              OK
            </b-button>
          </div>
        </b-row>
      </b-container>
    </b-modal>
    <save-indicator ref="saveIndicator" />
  </b-row>
</template>

<script>
import moment from "moment";
import Cropper from "cropperjs";
import _ from "lodash";
import { getCompaniesMinimal } from "@/apis/companies";
import {
  ellipsify,
  getInitials,
  getLoggedInUser,
  isAdmin,
  isOwner
} from "@/utils/utils";
import {
  ACCEPTED_IMAGE_FILE_TYPES,
  countriesListJSON,
  DEBOUNCE_DELAY,
  HEADROOM_BILLING_ENTITIES,
  infraOptions,
  internalCustomerEmailSet,
  linkedinRegex,
  ONBOARDING_INTAKE,
  profileTypes,
  QUESTION_TYPE_TEXT,
  timeZones
} from "@/utils/constants";
import {
  archiveOrDeleteAccount,
  deleteAssignedOwner,
  deleteSelectedAssistants,
  getAllArchivedOrDeletedAccounts,
  getAssignedAssistantsList,
  getAssignedOwnersList,
  getCustomerAddress,
  getCustomerDetails,
  getOwnersList,
  getSubmissions,
  patchCommunications,
  patchCustomerAddress,
  patchCustomerBasicDetails,
  patchCustomerOtherDetails,
  patchIntakeSubmissions,
  postAssignedAssistantsList,
  postAssignedOwner,
  postCustomerAddress,
  unarchiveCustomerAccount
} from "@/apis/customers/index";
import {
  extend,
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";
import { getAssistantsList } from "@/apis/assistants/index";
import { email } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import {
  getCommunicationIDs,
  patchAvatar,
  postCommunications
} from "@/apis/auth";
import SaveIndicator from "@/components/indicators/SaveIndicator.vue";
import RemoveEATooltip from "./components/RemoveEATooltip.vue";

extend("required", {
  message: () => "This is a required field"
});
extend("requiredCountry", {
  message: () => "This is a required field",
  validate: value => {
    if (Object.keys(value).length === 0) {
      return false;
    } else {
      return true;
    }
  }
});
extend("email", {
  ...email,
  message: "Email is not valid"
});
let linkedinErrorMessage =
  "Linkedin URL should be in this format: https://www.linkedin.com/in/dave";
extend("linkedinRegex", {
  message: () => `${linkedinErrorMessage}`,
  validate: value => {
    let mustContainTheseChars = linkedinRegex;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      linkedinErrorMessage =
        "Linkedin URL should be in this format: https://www.linkedin.com/in/dave";
      return false;
    }
  }
});

let customerHoursErrorMessage = "Customer hours should be numbers only.";
extend("customerHours", {
  message: () => `${customerHoursErrorMessage}`,
  validate: value => {
    let mustContainTheseChars = /^\d+$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      customerHoursErrorMessage = "Customer hours should be numbers only.";
      return false;
    }
  }
});

let dobMessage = "YYYY-MM-DD format required";
extend("dob", {
  message: () => dobMessage,
  validate: value => {
    // treat empty value as valid (DOB optional)
    if (!value || (typeof value === "string" && value.trim().length === 0)) {
      return true;
    }
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      if (moment().isSameOrAfter(moment(value).add(18, "years"))) {
        return true;
      } else {
        dobMessage = "Age should be greater than 18 years";
        return false;
      }
    } else {
      dobMessage = "YYYY-MM-DD format required";
      return false;
    }
  }
});
extend("dated", {
  message: () => dobMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      dobMessage = "YYYY-MM-DD format required";
      return false;
    }
  }
});
extend("dateDifference", {
  params: ["target"],
  validate(value, { target }) {
    if (target && target.length !== 0) {
      if ((target && target.length > 0 && value <= target) || target === null) {
        return true;
      } else if (target && target.length > 0 && value > target) {
        return false;
      }
    } else {
      return true;
    }
  },
  message: "Start date cannot be greater than end date"
});

export default {
  name: "CustomerContact",
  components: {
    Multiselect,
    ValidationObserver,
    ValidationProvider,
    SaveIndicator,
    RemoveEATooltip,
  },
  computed: {
    loggedInUser() {
      return getLoggedInUser();
    },
    // Owner assignment is an admin action; EAs and Owners see it read-only.
    canEditOwners() {
      return this.role === "admin";
    },
    // Keep assigned owners out of the dropdown; they reappear once removed.
    availableOwnersList() {
      const selectedIds = new Set(
        this.selectedOwners.map(owner => String(owner.profileId))
      );
      return this.ownersList.filter(
        owner => !selectedIds.has(String(owner.profileId))
      );
    },
    ownerPickerEmptyMessage() {
      if (!this.ownersList.length) {
        return "No owners available";
      }
      if (!this.availableOwnersList.length) {
        return "All owners are assigned";
      }
      return "No owners available";
    },
    isOwnerUser() {
      return isOwner();
    },
    // Archived/deleted profiles freeze this form for everyone. Owners get the
    // same frozen form permanently - the API refuses their writes either way,
    // so the fields should not invite an edit that cannot be saved.
    isFieldsDisabled() {
      return this.isOwnerUser || this.isDelete === true || this.isDelete === false;
    },
    isUserPrimaryEA() {
      let defaultAssistant = this.selectedAssistants.find(
        assistant => assistant.isDefault
      );
      if (!defaultAssistant) return false;

      let loggedInUser = getLoggedInUser();
      return loggedInUser.profileUserId === defaultAssistant.profileId;
    },
    isUserSecondaryEA() {
      let defaultAssistant = this.selectedAssistants.find(
        assistant => assistant.isDefault
      );
      if (!defaultAssistant) return false;

      let loggedInUser = getLoggedInUser();
      return (
        loggedInUser.profileUserId !== defaultAssistant.profileId && !isAdmin()
      );
    },
    enableAssistantSelect() {
      // Assigning EAs is not an Owner's job; the API refuses it too.
      if (this.isOwnerUser || this.isSavingAssistant) {
        return false;
      }
      let defaultAssistant = this.selectedAssistants.find(
        assistant => assistant.isDefault
      );
      if (!defaultAssistant) return false;

      if (
        this.assistantsList.length === 0 ||
        this.selectedAssistants.length === 0
      ) {
        return false;
      }
      return true;
    },
    disableDeleteButton() {
      let { deleteModal } = this;
      const isPrimaryEASelected =
        deleteModal.isPrimaryEA && deleteModal.selectedEAId !== null;
      return deleteModal.loading || !isPrimaryEASelected;
    },
    computedAssistants() {
      let options = this.assistantsList.map(assistant => ({
        text: assistant.text,
        value: assistant.profileId
      }));
      options.push({
        text: "Select Primary EA",
        value: null
      });
      return options;
    },
    ...mapState("authModule", ["role"])
  },
  props: ["updateAvatar"],
  data() {
    return {
      isEditCompanyDisabled: true,
      ACCEPTED_IMAGE_FILE_TYPES,
      maxBirthDate: moment()
        .subtract(18, "years")
        .format("YYYY-MM-DD"),
      minBirthDate: moment()
        .subtract(125, "years")
        .format("YYYY-MM-DD"),
      intakeFormId: "",
      deleteModal: {
        isPrimaryEA: false,
        loading: false,
        selectedEAId: null,
        removedOption: {
          text: "Sample Name"
        },
        visible: false
      },
      emailError: false,
      internalCustomer: false,
      isLoading: true,
      questions: [],
      linkedInURL: "",
      isSavingAssistant: false,
      isSavingUnarchive: null,
      profileArchived: false,
      showCropper: false,
      removedOptions: [],
      birthDate: "",
      startDate: "",
      endDate: "",
      formatted: "",
      selected: "",
      firstName: "",
      lastName: "",
      customerName: "",
      addressId: "",
      userId: "",
      customerIdToUnarchive: "",
      showUnarchivedBtn: false,
      infrastructure: [],
      infraOptions: infraOptions,
      profileId: "",
      isSaving: false,
      isSavingArchive: false,
      isDeletingAccount: false,
      isAccountDeleted: false,
      isDelete: null,
      archivedId: "",
      defaultCommunications: [],
      headroomName: "",
      emailAddress: "",
      homeAddress: {
        streetName: "",
        streetNumber: "",
        postalCode: ""
      },
      isAddressFormValid: true,
      selectedProfileType: [],
      communications: [],
      leftColumnFormValid: false,
      rightColumnFormValid: false,
      alertMsg: "",
      showAlert: false,
      showArchiveDeleteAlert: false,
      alertDuration: null,
      minEndDate: "",
      addressList: [],
      selectedTimeZone: null,
      fileURL: "",
      selectedFile: null,
      timeZone: timeZones,
      profileTypes: profileTypes,
      customerCompany: { value: "", text: "Select Company" },
      companyMaxSeatsError: "",
      customerMembership: null,
      customerMembershipHours: null,
      customerHours: null,
      billingEntity: "N/A",
      avatar: null,
      avatarName: "",
      photoUpdated: false,
      photoError: false,
      photoTokenError: false,
      photoFileTypeError: false,
      cropperLoading: false,
      selectedAssistants: [],
      assistantsList: [],
      selectedOwners: [],
      ownersList: [],
      ownerError: null,
      selectedCity: null,
      selectedCountry: {
        id: null,
        text: ""
      },
      countries: [],
      image: null,
      debouncedUpdatePreview: _.debounce(this.updatePreview, 257),
      cropper: null,
      canvas: null,
      companies: [],
      showArchive: false,
      isCustomerArchived: true,
      requiredField: "This is a required field",
      isBlacklisted: false
    };
  },
  created() {
    this.minEndDate = this.startDate;
    const getCountriesList = this.getCountries();
    const getIsArchivedOrNot = this.getArchivedOrDeletedAccountsList();
    const customerInfo = this.getCustomerInfo();
    const customerAddress = this.getCustomerAddressInfo();
    const allAssistants = this.getAllAssistants();
    const assignedAssistants = this.getAssignedAssistants();
    const allOwners = this.getAllOwners();
    const assignedOwners = this.getAssignedOwners();
    const intakeInfo = this.getIntakeInfo();
    this.getCompaniesList();
    // ! watch for store state update -> then update `this.isEditCompanyDisabled`
    this.isEditCompanyDisabled = !this.isAdmin();
    Promise.allSettled([
      getCountriesList,
      getIsArchivedOrNot,
      customerInfo,
      customerAddress,
      allAssistants,
      assignedAssistants,
      allOwners,
      assignedOwners,
      intakeInfo
    ])
      .then(() => {
        console.log("success");
      })
      .catch(err => {
        console.log(err);
        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  mounted() {
    this.showSaveIndicator = this.$refs.saveIndicator.showSaveIndicator;
    this.showSaveIndicatorSaved = this.$refs.saveIndicator.showSaveIndicatorSaved;
    this.showSaveIndicatorError = this.$refs.saveIndicator.showSaveIndicatorError;
    this.clearSaveIndicators = this.$refs.saveIndicator.clearSaveIndicators;

    this.saveCustomerBasicDetails = _.debounce(
      this.saveCustomerBasicDetails,
      DEBOUNCE_DELAY
    );
    this.updateCommunications = _.debounce(
      this.updateCommunications,
      DEBOUNCE_DELAY
    );
    this.updateCustomerOtherDetails = _.debounce(
      this.updateCustomerOtherDetails,
      DEBOUNCE_DELAY
    );
    this.saveAddress = _.debounce(this.saveAddress, DEBOUNCE_DELAY);
    this.patchIndex = _.debounce(this.patchIntake, DEBOUNCE_DELAY);
  },
  watch: {
    startDate() {
      this.minEndDate = this.startDate;
    },
    canEditOwners(canEdit) {
      if (canEdit && !this.ownersList.length) {
        this.getAllOwners();
      }
    }
  },
  methods: {
    isAdmin,
    parseInt,
    ellipsify,
    getInitials,
    onRemoveOption(option, remove) {
      // the admin and primary EA can remove anything, but a PA can't remove a primary EA
      const isPrimaryUser = this.isUserPrimaryEA;
      if (isAdmin() || isPrimaryUser || !option.isDefault) {
        remove(option);
      }
    },

    uploadClear(event) {
      event.target.value = "";
      this.photoFileTypeError = false;
    },

    getBillingEntityName(billingEntity) {
      return billingEntity ? HEADROOM_BILLING_ENTITIES[billingEntity] : "N/A";
    },

    uploadFile(event) {
      const extensions = this.ACCEPTED_IMAGE_FILE_TYPES.split(",").filter(
        item => item[0] === "."
      );

      this.selectedFile = event.target.files[0];

      this.photoFileTypeError = false;
      const fileExtension = `.${
        this.selectedFile.name.split(".").reverse()[0]
      }`;
      const isRestrictedFileType = !extensions.includes(fileExtension);
      if (isRestrictedFileType) {
        this.photoFileTypeError = true;
        event.target.value = "";
        return;
      }

      this.fileURL = URL.createObjectURL(this.selectedFile);
      this.showCropper = true;
      if (this.showCropper) {
        setTimeout(() => {
          this.setupCropperInstance();
        }, 100);
      }
    },

    setupCropperInstance() {
      this.image = this.$refs.source;
      this.cropper = new Cropper(this.image, {
        crop: this.debouncedUpdatePreview,
        autoCropArea: 1,
        aspectRatio: 1,
        viewMode: 0,
        scalable: false,
        zoomable: false
      });
    },

    updatePreview() {
      this.canvas = this.cropper.getCroppedCanvas();
    },
    submitImage() {
      if (this.canvas) {
        this.cropperLoading = true;
        this.canvas.toBlob(blob => {
          if (blob) {
            let myFile = new File([blob], "avatar.png");
            const formData = new FormData();
            formData.append("avatar", myFile);
            this.showSaveIndicator();
            patchAvatar(this.$route.params.profileId, formData, "customer")
              .then(res => {
                this.showCropper = false;
                this.avatar = res.data.avatarThumbnail;
                this.$emit("updateAvatar", res.data.avatarThumbnail);
                this.photoUpdated = true;
                this.photoError = false;
                this.showSaveIndicatorSaved();
              })
              .catch(err => {
                if (err.response.status === 401) {
                  this.photoTokenError = true;
                }
                this.showCropper = false;
                console.log(err.response);
                this.showSaveIndicatorError();
              })
              .finally(() => {
                this.cropperLoading = false;
              });
          }
        });
      }
    },
    resetModal() {
      this.fileURL = "";
      this.showCropper = false;
      this.selectedFile = null;
    },
    async getCountries() {
      this.countries = countriesListJSON.map(item => {
        return {
          text: item.name,
          id: item.id
        };
      });
    },
    async patchIntake(index) {
      let isValid = (await this.$refs.questionsValidator[index].validate())
        .valid;
      if (!isValid) {
        return;
      }
      this.showSaveIndicator();
      try {
        await Promise.all(
          this.questions.map(question => {
            let payload = {
              answer: {
                answer: question.answer.answer
              }
            };
            return patchIntakeSubmissions(
              this.intakeFormId,
              question.id,
              payload
            );
          })
        );
        this.showSaveIndicatorSaved();
      } catch (e) {
        this.showSaveIndicatorError();
      }
    },
    async getIntakeInfo() {
      await getSubmissions(this.$route.params.profileId)
        .then(res => {
          this.intakeFormId = res.data.results
            .filter(item => item.form.formType === ONBOARDING_INTAKE)
            .map(el => el.form.id)[0];
          this.questions = res.data.results
            .filter(item => item.form.formType === ONBOARDING_INTAKE)
            .map(el => el.submissions)[0]
            .filter(
              item =>
                item.formQuestion.question.questionType === QUESTION_TYPE_TEXT
            )
            .sort((a, b) => a.formQuestion.order - b.formQuestion.order);
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getCustomerInfo() {
      await getCustomerDetails(this.$route.params.profileId)
        .then(res => {
          let { user, profile, communications } = res.data;
          this.firstName = user.firstName;
          this.lastName = user.lastName;
          this.avatar = user.avatarThumbnail;
          this.avatarName =
            user.firstName?.charAt(0).toUpperCase() +
            user.lastName?.charAt(0).toUpperCase();
          this.photoUpdated = user.avatarThumbnail !== null ? true : false;
          this.customerName = `${this.firstName} ${this.lastName}`;
          this.emailAddress = user.email;
          this.internalCustomer = internalCustomerEmailSet.has(user.email);
          this.infrastructure = [
            ...profile.communicationManager.selectedMedium
          ];
          this.birthDate = user.birthday;
          this.selectedTimeZone = profile.timezone;
          this.headroomName = profile.displayName;
          this.linkedInURL = profile.linkedin;
          this.selectedProfileType = profile.profileType.selectedProfileTypes;
          this.startDate = profile.startDate;
          this.endDate = profile.endDate;
          this.userId = user.id;
          this.profileId = profile.id;
          this.communications = communications.sort(
            (a, b) => a.communication.order - b.communication.order
          );
          this.customerCompany = profile.company
            ? { value: profile.company.id, text: profile.company.name }
            : { value: "", text: "Select Company" };
          this.customerMembership = profile.membership
            ? profile.membership.title
            : "N/A";
          this.customerMembershipHours = profile.membershipHours
            ? profile.membershipHours
            : "Unlimited";
          this.customerHours = profile.customerHours
            ? profile.customerHours
            : profile.membershipHours;
          this.billingEntity = this.getBillingEntityName(profile.billingEntity);
          this.isBlacklisted = res.data.isBlacklisted;
        })
        .catch(err => console.log(err));
    },
    async getCustomerAddressInfo() {
      await getCustomerAddress(this.$route.params.profileId)
        .then(res => {
          this.addressList = res.data.results;
          if (res.data.results.length > 0) {
            let { city, address, id, country } = res.data.results[0];
            this.selectedCity = city;
            this.homeAddress = address;
            this.addressId = id;
            this.selectedCountry = this.countries.find(
              item => item.text === country
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    async getAllAssistants() {
      await getAssistantsList()
        .then(res => {
          this.assistantsList = res.data.results.map(assistant => {
            return {
              text: `${assistant.user.firstName} ${assistant.user.lastName} `,
              profileId: assistant.assistantProfile.profile,
              workHours: assistant.assistantProfile.workHours,
              avatarThumbnail: assistant.user.avatarThumbnail
            };
          }); //assistantProfile.id
        })
        .catch(err => console.log(err));
    },
    ensureOwnersLoaded() {
      if (this.canEditOwners && !this.ownersList.length) {
        this.getAllOwners();
      }
    },
    async getAllOwners() {
      // Only an admin can change the assignment, so only an admin needs the
      // full picker list.
      if (!this.canEditOwners) return;
      await getOwnersList()
        .then(res => {
          this.ownersList = res.data.results.map(owner => ({
            text: owner.fullname,
            profileId: String(owner.id),
            avatarThumbnail: owner.avatarThumbnail
          }));
        })
        .catch(err => console.log(err));
    },
    async getAssignedOwners() {
      await getAssignedOwnersList(this.$route.params.profileId)
        .then(res => {
          this.selectedOwners = res.data.results.map(item => ({
            text: `${item.owner.firstName} ${item.owner.lastName}`,
            profileId: String(item.owner.id),
            avatarThumbnail: item.owner.avatarThumbnail,
            id: item.id
          }));
        })
        .catch(err => console.log(err));
    },
    async onAddOwner(option) {
      this.ownerError = null;
      try {
        this.showSaveIndicator();
        const res = await postAssignedOwner(this.$route.params.profileId, {
          customer: this.$route.params.profileId,
          owner: option.profileId
        });
        this.selectedOwners = [
          ...this.selectedOwners,
          { ...option, id: res.data.id }
        ];
        this.showSaveIndicatorSaved();
      } catch (err) {
        this.ownerError =
          err.response?.data?.detail || "Unable to assign this owner.";
        this.showSaveIndicatorError();
      }
    },
    async onRemoveOwner(option) {
      this.ownerError = null;
      const assignmentId = option.id;
      if (!assignmentId) {
        this.ownerError = "Unable to remove this owner (missing assignment id).";
        return;
      }
      // Keep the current list so the tag can be restored if the call fails.
      const previouslySelected = [...this.selectedOwners];
      this.selectedOwners = this.selectedOwners.filter(
        owner =>
          String(owner.profileId) !== String(option.profileId)
      );
      try {
        this.showSaveIndicator();
        await deleteAssignedOwner(this.$route.params.profileId, assignmentId);
        this.showSaveIndicatorSaved();
      } catch (err) {
        this.selectedOwners = previouslySelected;
        this.ownerError =
          err.response?.data?.detail || "Unable to remove this owner.";
        this.showSaveIndicatorError();
      }
    },
    async getAssignedAssistants() {
      await getAssignedAssistantsList(this.$route.params.profileId)
        .then(res => {
          this.selectedAssistants = res.data.results.map(item => {
            // return item.assistant.profile.id;
            return {
              text: `${item.assistant.profile.user.firstName} ${item.assistant.profile.user.lastName} `,
              profileId: item.assistant.profile.id,
              assistantOpenHandoverTasksCount:
                item.assistantOpenHandoverTasksCount,
              assistantOpenTasksCount: item.assistantOpenTasksCount,
              workHours: item.assistant.profile.assistantProfile.workHours,
              id: item.id,
              avatarThumbnail: item.assistant.profile.user.avatarThumbnail,
              isDefault: item.isDefault
            };
          }); // assistant -> profile -> id
        })
        .catch(err => console.log(err));
    },
    async getArchivedOrDeletedAccountsList() {
      // Owners cannot archive or unarchive, so the controls this drives are
      // hidden for them and the endpoint stays closed to the role.
      if (isOwner()) return;
      await getAllArchivedOrDeletedAccounts()
        .then(res => {
          let getArchiveDeleteForCurrentProfile = res.data.results.filter(
            item => item.profile === this.$route.params.profileId
          );
          if (getArchiveDeleteForCurrentProfile.length > 0) {
            this.customerIdToUnarchive =
              getArchiveDeleteForCurrentProfile[0].id;
          }
          if (getArchiveDeleteForCurrentProfile.length > 0) {
            this.isDelete = res.data.results
              .filter(item => {
                if (
                  item.profile === this.$route.params.profileId &&
                  !item.isDelete
                ) {
                  return (
                    item.profile === this.$route.params.profileId &&
                    item.isDelete === false
                  );
                }
              })
              .map(i => i.isDelete)[0];
            this.isAccountDeleted = res.data.results
              .filter(item => {
                if (
                  item.profile === this.$route.params.profileId &&
                  item.isDelete
                ) {
                  return (
                    item.profile === this.$route.params.profileId &&
                    item.isDelete === true
                  );
                }
              })
              .map(i => i.isDelete)[0];
            if (this.isDelete === false) {
              this.showUnarchivedBtn = true;
            }
          }
        })
        .catch(err => console.log(err));
    },
    async onAddAssistant(selectedAssistant, isDefault = false) {
      // a secondary EA can't make any changes
      if (this.isUserSecondaryEA) {
        return;
      }
      let payload = [
        {
          assistant: selectedAssistant.profileId,
          customer: this.$route.params.profileId,
          isDefault: !!isDefault
        }
      ];
      try {
        this.isSavingAssistant = true;
        this.showSaveIndicator();
        let apiResponse = await postAssignedAssistantsList(
          this.$route.params.profileId,
          payload
        );
        selectedAssistant.id = apiResponse.data[0].id;
        selectedAssistant.isDefault = !!isDefault;
        this.selectedAssistants.push(selectedAssistant);
        this.showSaveIndicatorSaved();
      } catch (e) {
        this.showSaveIndicatorError();
      } finally {
        this.isSavingAssistant = false;
      }
    },
    onRemoveAssistant(removedOption) {
      let loggedInUser = getLoggedInUser();

      // a secondary EA can't make any changes except remove himself
      if (
        this.isUserSecondaryEA &&
        loggedInUser.profileUserId !== removedOption.profileId
      ) {
        return;
      }
      // don't allow the EA to remove the default (primary) EA
      let defaultAssistant = this.selectedAssistants.find(
        assistant => assistant.isDefault
      );
      let assistant = this.assistantsList.find(
        assistant => assistant.profileId === removedOption.profileId
      );

      const profileId = removedOption.profileId;
      if (profileId === defaultAssistant.profileId && this.isUserSecondaryEA) {
        return;
      }
      let openTasks =
        removedOption.assistantOpenHandoverTasksCount +
        removedOption.assistantOpenTasksCount;
      if (openTasks > 0) {
        return;
      }
      this.deleteModal.isPrimaryEA =
        defaultAssistant.profileId === removedOption.profileId;
      this.deleteModal.selectedEAId = null;
      this.deleteModal.removedOption = removedOption;
      this.deleteModal.removedOption.workHours = assistant.workHours;
      this.deleteModal.visible = true;
    },
    async changePrimaryAssistant() {
      let selectedAssistant = this.assistantsList.find(
        assistant => assistant.profileId === this.deleteModal.selectedEAId
      );

      // there is the case where the user wants to make an existing secondary EA the primary EA
      // the variable isAlreadySelected checks this condition
      // in this case we have to check if the new primary EA is already an secondary EA
      // if they are, then we need to remove them before adding them as a primary EA to avoid an error
      const isAlreadySelected = this.selectedAssistants.some(
        assistant => assistant.profileId === selectedAssistant.profileId
      );
      if (isAlreadySelected) {
        await this.removeAssistant({
          id: this.selectedAssistants.find(
            assistant => assistant.profileId === selectedAssistant.profileId
          ).id,
          profileId: selectedAssistant.profileId
        }); 
      }
      await this.onAddAssistant(selectedAssistant, true);
      await this.removeAssistant();
    },
    async removeAssistant(forceRemoveOption) {
      // if forceRemoveOption is not undefined then remove it, not the option from the delete modal
      let { removedOption } = this.deleteModal;

      // checking if forceRemoveOption is present and valid
      if (
        forceRemoveOption &&
        forceRemoveOption.id &&
        forceRemoveOption.profileId
      ) {
        removedOption = forceRemoveOption;
      }
      try {
        this.isSavingAssistant = true;
        this.deleteModal.loading = true;
        this.showSaveIndicator();
        await deleteSelectedAssistants(
          this.$route.params.profileId,
          removedOption.id
        );
        this.selectedAssistants = this.selectedAssistants.filter(
          assistant => assistant.profileId !== removedOption.profileId
        );
        this.showSaveIndicatorSaved();
        const hasEARemovedHimself =
          removedOption.profileId === this.loggedInUser.profileUserId;

        // redirect to the customers listing page if the EA has removed himself
        if (hasEARemovedHimself) {
          this.$router.replace({
            name: "DedicatedCustomers"
          });
        }
      } catch (e) {
        this.showSaveIndicatorError();
      } finally {
        this.isSavingAssistant = false;
        this.deleteModal.loading = false;
        this.deleteModal.visible = false;
      }
    },
    async deleteAssistants() {
      this.isSaving = true;
      for (let i = 0; i < this.removedOptions.length; i++) {
        await deleteSelectedAssistants(
          this.$route.params.profileId,
          this.removedOptions[i].id
        );
      }
    },
    unArchiveAccount() {
      this.isSavingUnarchive = true;
      unarchiveCustomerAccount(this.customerIdToUnarchive)
        .then(() => {
          this.showUnarchivedBtn = false;
          this.getArchivedOrDeletedAccountsList();
          this.showAlert = true;
          this.isDelete = null;
          this.alertMsg = "Unarchived profile successfully!";
        })
        .catch(err => {
          this.isSavingUnarchive = false;
          console.log(err);
          this.showAlert = true;
          this.alertMsg = "Failed to archive unarchive profile!";
        })
        .finally(() => {
          this.isSavingUnarchive = false;
        });
    },
    archiveAccount() {
      this.isSavingArchive = true;
      const data = {
        profile: this.$route.params.profileId,
        isDelete: false
      };
      archiveOrDeleteAccount(data)
        .then(res => {
          this.isDelete = res.data.isDelete;
          this.showUnarchivedBtn = true;
          this.getArchivedOrDeletedAccountsList();
          this.profileArchived = true;
          this.archivedId = res.data.id;
          this.isSavingArchive = false;
          this.showAlert = true;
          this.alertMsg = "Archived profile successfully!";
          this.showArchiveModal();
        })
        .catch(err => {
          console.log(err);
          this.isSavingArchive = false;
          this.showUnarchivedBtn = false;
          this.showAlert = true;
          if (err.response.data.detail) {
            this.alertMsg = err.response.data.detail;
          } else {
            this.alertMsg = "Failed to archive profile!";
          }
        });
    },
    showArchiveModal() {
      this.showArchive = true;
    },
    closeArchiveModal() {
      this.showArchive = false;
      this.archiveError = null;
      this.isCustomerArchived = false;
      this.gotoCustomerListing();
    },
    gotoCustomerListing() {
      if (isAdmin()) {
        this.$router.replace({
          name: "CustomersListAdmin"
        });
      } else {
        this.$router.replace({
          name: "DedicatedCustomers"
        });
      }
    },
    deleteAccount() {
      this.isDeletingAccount = true;
      if (this.isDelete === false) {
        const data = {
          profile: this.$route.params.profileId,
          isDelete: true
        };
        archiveOrDeleteAccount(data)
          .then(res => {
            this.isAccountDeleted = res.data.isDelete;
            this.deletedId = res.data.id;
            this.isDeletingAccount = false;
            this.getArchivedOrDeletedAccountsList();
            this.showAlert = true;
            this.alertMsg = "Deleted account successfully!";
          })
          .catch(err => {
            console.log(err);
            this.isDeletingAccount = false;
            this.showAlert = true;
            this.alertMsg = "Failed to delete account!";
          });
      } else {
        this.isDeletingAccount = false;
        this.showAlert = true;
        this.alertMsg = "Please archive an account first before deleting it!";
      }
    },
    async postAssignedAssistantsList() {
      let data = this.selectedAssistants
        // don't post already existing assistants as the API throws an error
        .filter(assistant => assistant.local)
        .map(item => {
          return {
            assistant: item.profileId,
            customer: this.$route.params.profileId
          };
        });
      await postAssignedAssistantsList(this.$route.params.profileId, data);
    },

    async updateCommunications() {
      let data = [];
      this.showSaveIndicator();
      if (this.communications.length === 0) {
        getCommunicationIDs("customer").then(res => {
          this.defaultCommunications = res.data.results;
          for (let i = 0; i < this.defaultCommunications.length; i++) {
            data.push({
              communication: this.defaultCommunications[i].id,
              value: ""
            });
          }
          postCommunications(this.$route.params.profileId, data)
            .then(() => {
              this.showSaveIndicatorSaved();
            })
            .catch(err => {
              console.log(err);
              this.showSaveIndicatorError();
            });
        });
      } else {
        let data = this.communications.map(communication => ({
          id: communication.id,
          value: communication.value
        }));
        try {
          await patchCommunications(this.$route.params.profileId, data);
          this.showSaveIndicatorSaved();
        } catch (e) {
          console.log(e);
          this.showSaveIndicatorError();
        }
      }
    },

    async updateCustomerOtherDetails() {
      const isValid =
        this.infrastructure.length > 0 &&
        this.selectedTimeZone !== null &&
        this.customerCompany?.value?.length > 0 &&
        this.selectedProfileType.length > 0 &&
        (await this.$refs.startDateValidator.validate()).valid &&
        (await this.$refs.endDateValidator.validate()).valid &&
        (await this.$refs.linkedInValidator.validate()).valid &&
        (await this.$refs.customerHoursValidator.validate()).valid;

      if (!isValid) {
        return;
      }
      const data = {
        communicationManager: {
          selectedMedium: this.infrastructure
        },
        company: this.customerCompany.value,
        displayName: this.headroomName,
        linkedin: this.linkedInURL,
        customerHours: this.customerHours,
        timezone: this.selectedTimeZone,
        profileType: { selectedProfileTypes: this.selectedProfileType },
        startDate: this.startDate,
        endDate: this.endDate && this.endDate.length > 0 ? this.endDate : null,
        isBlacklisted: this.isBlacklisted
      };

      this.showSaveIndicator();
      this.companyMaxSeatsError = "";

      patchCustomerOtherDetails(
        this.$route.params.profileId,
        this.profileId,
        data
      )
        .then(res => {
          this.customerMembership = res.data.profile.profile.membership.title;
          this.customerMembershipHours = res.data.profile.profile
            .membershipHours
            ? res.data.profile.profile.membershipHours
            : "Unlimited";
          this.customerHours = res.data.profile.profile.customerHours
            ? res.data.profile.profile.customerHours
            : null;
          this.billingEntity = this.getBillingEntityName(
            res.data.profile.profile.billingEntity
          );
          this.isBlacklisted = res.data.profile.isBlacklisted;
          this.showSaveIndicatorSaved();
          this.$emit("updateMembership", this.customerMembership);
        })
        .catch(error => {
          this.clearSaveIndicators();
          const errorCode = error?.response?.data?.nonFieldErrors[0];
          console.log(errorCode);
          this.companyMaxSeatsError = `${this.customerCompany.text}'s membership has reached max seat limit.
          Please check the company's subscription.`;
        });
    },

    async postCustomerAddress() {
      const data = {
        city: this.selectedCity,
        country: this.selectedCountry.text,
        address: this.homeAddress
      };
      await postCustomerAddress(this.$route.params.profileId, data);
    },

    async saveCustomerAddress() {
      this.isSaving = true;
      const data = {
        country: this.selectedCountry.text,
        city: this.selectedCity,
        address: this.homeAddress
      };
      await patchCustomerAddress(
        this.$route.params.profileId,
        this.addressId,
        data
      );
    },

    saveAllInfo() {
      // unused
      this.$refs.leftColForm
        .validate()
        .then(val => {
          this.leftColumnFormValid = val;
        })
        .then(() => {
          this.$refs.rightColForm
            .validate()
            .then(val => {
              this.rightColumnFormValid = val;
            })
            .finally(() => {
              if (
                !this.photoUpdated ||
                !this.leftColumnFormValid ||
                !this.rightColumnFormValid
              ) {
                console.log("error");
                this.showAlert = true;
                this.alertMsg = "There are invalid form fields";
                if (!this.photoUpdated) {
                  this.photoError = true;
                }
              } else {
                this.emailError = false;
                this.deleteAssistants().then(() => {
                  let customerAddress;
                  if (this.addressList.length > 0) {
                    customerAddress = this.saveCustomerAddress();
                  } else if (this.addressList.length === 0) {
                    customerAddress = this.postCustomerAddress();
                  }
                  let [firstName, ...lastName] = this.customerName.split(" ");
                  this.firstName = firstName;
                  this.lastName = lastName.join(" ");
                  const data = {
                    firstName: this.firstName,
                    lastName: this.lastName,
                    birthday: this.birthDate,
                    email: this.emailAddress.toLowerCase()
                  };
                  patchCustomerBasicDetails(
                    this.$route.params.profileId,
                    this.userId,
                    data
                  )
                    .then(res => {
                      this.$emit("updateCustomerDetails", res.data);
                      const customerMiscDetails = this.updateCustomerOtherDetails();
                      const communications = this.updateCommunications();
                      const customerIntake = this.patchIntake();
                      let assignedAssistantsList;

                      assignedAssistantsList = this.postAssignedAssistantsList();
                      Promise.allSettled([
                        customerAddress,
                        customerMiscDetails,
                        communications,
                        assignedAssistantsList,
                        customerIntake
                      ])
                        .then(result => {
                          const allFulfilled = val =>
                            val.status === "fulfilled";
                          // If all the API calls have no errors
                          if (result.every(allFulfilled)) {
                            this.showAlert = true;
                            this.alertMsg = "Details saved successfully!";
                            this.$emit(
                              "updateMembership",
                              this.customerMembership
                            );
                          } else {
                            // If any of the API calls have errors
                            this.showAlert = true;
                            this.alertMsg = "Some error occurred";
                          }
                        })
                        .then(() => {
                          this.isSaving = false;
                          // after a successful save, everything becomes nonlocal
                          this.selectedAssistants.forEach(assistant => {
                            assistant.local = false;
                          });
                          // need to refetch the data in order to keep the ids in the backend in sync with the frontend
                          this.getAssignedAssistants();
                          this.removedOptions = [];
                        })
                        .catch(err => {
                          console.log(err.response.data);
                          this.isSaving = false;
                        });
                    })
                    .catch(err => {
                      this.showAlert = true;
                      if (err.response.status === 401) {
                        this.alertMsg =
                          "User token expired. Please logout and login again.";
                      } else {
                        this.alertMsg = "Some error occurred";
                      }
                      this.emailError = true;
                      this.isSaving = false;
                    });
                });
              }
            });
        });
    },
    async saveAddress() {
      const isValid =
        this.selectedCountry.text.length > 0 &&
        this.selectedCity.length > 0 &&
        this.homeAddress.streetName.length > 0 &&
        this.homeAddress.postalCode.length > 0;

      if (isValid) {
        this.showSaveIndicator();
        try {
          if (this.addressList.length > 0) {
            await this.saveCustomerAddress();
          } else {
            await this.postCustomerAddress();
          }
          this.showSaveIndicatorSaved();
        } catch (e) {
          this.showSaveIndicatorError();
        }
      }
    },
    async saveCustomerBasicDetails() {
      try {
        const isValid =
          this.customerName.length > 0 &&
          (await this.$refs.dobValidator.validate()).valid &&
          (await this.$refs.emailValidator.validate()).valid;

        if (!isValid) {
          return;
        }

        this.emailError = false;
        let [firstName, ...lastName] = this.customerName.split(" ");
        this.firstName = firstName;
        this.lastName = lastName.join(" ");
        const data = {
          firstName: this.firstName,
          lastName: this.lastName,
          birthday:  this.birthDate && this.birthDate.trim().length > 0 ? this.birthDate : null,
          email: this.emailAddress.toLowerCase()
        };
        this.showSaveIndicator();
        try {
          let apiResponse = await patchCustomerBasicDetails(
            this.$route.params.profileId,
            this.userId,
            data
          );
          this.showSaveIndicatorSaved();
          this.$emit("updateCustomerDetails", apiResponse.data);
        } catch (e) {
          if (e.response.data.email) {
            this.emailError = true;
            this.clearSaveIndicators();
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    onSelectCompany(option) {
      this.customerCompany = option;
      this.updateCustomerOtherDetails();
    },
    async getCompaniesList() {
      await getCompaniesMinimal(true)
        .then(res => {
          let data = res.data.results;
          this.companies = data.map(company => {
            return { value: company.id, text: company.name };
          });
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";
@import "~@/scss/common/fonts.scss";

::v-deep .custom-checkbox label {
  background-color: $primary !important;
  border-radius: 22px;
  font-weight: 600;
  width: 15rem;
  padding: 1.2rem;
}
.communication-icons {
  width: 40px;
  height: 40px;
}
.answers-form-group:not(:last-child) {
  margin-bottom: 5rem;
}
.answers-form-group:last-child {
  margin-bottom: 2rem;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
.archive-btn-container {
  right: -2rem;
}
.delete-container {
  right: 0rem;
}
.btn-top {
  top: 0.5rem;
}
.btn-bottom {
  bottom: 1rem;
}
.communications-textbox {
  right: 0;
}

.tooltips:hover .tooltiptext {
  visibility: visible;
}
.communications-column {
  padding-left: 7.5px;
}
.tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 0.2rem;
  padding-top: 0.5rem;
  position: absolute;
  z-index: 1;
}
.validationSpan {
  width: 100%;
}
.assistant-tag {
  display: inline-flex;
  border: 1px solid $default-border;
  border-radius: 999px;
  margin: 5px 10px 5px 0;
  align-items: center;
  box-shadow: 1px 1px 1px #fff;
  .avatar-wrapper {
  }
  .title-wrapper {
    padding: 0 5px;
    .title {
      font-size: 1.4rem;
    }
  }
  .primary-label {
    span {
      background: $primary-dark;
      color: white;
      padding: 3px 5px;
      border-radius: 999px;
    }
  }
  .close-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 5px;
    font-size: 2rem;
    > .b-icon {
      cursor: pointer;
    }
  }
}
.assistant-multiselect {
  .multiselect__tags {
    padding-top: 5px;
    padding-bottom: 5px;
  }
}
::v-deep .logout-modal-body {
  // font-size: $font-size-lg;
  h1,
  h2,
  h3,
  h4 {
    margin: 0;
  }
  padding: 10px;
  > div {
    padding: 10px;
    line-height: normal;
  }
  > .title-row {
    h1 {
      font-size: 2.2rem !important;
      line-height: normal !important;
      font-weight: bold;
    }
  }
  .desc-row {
    h3 {
      color: $primary-dark;
      opacity: 0.5;
      font-size: 1.8rem !important;
    }
  }
  > .info-wrapper {
    display: flex;
    .ea-info {
      flex: 1;
      p {
        margin: 0;
        flex: 1;
        align-items: flex-end;
        display: flex;
      }
      p:nth-child(2) {
        align-items: flex-start;
      }
    }
    .right-button-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        padding: 8px 15px;
      }
    }
  }
  .modal-divider {
    margin: 0 10px;
    padding: 10px 0;
  }
  .select-row {
    h3 {
      color: $primary-dark;
      opacity: 0.5;
      font-size: $font-size-sm;
    }
  }
  > .button-row {
    button {
      padding: 8px 15px;
    }
  }
  .close-button {
    right: -28px;
    position: absolute;
    display: flex;
    top: -22px;
    background: transparent !important;
  }
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
</style>
